import { createQueryKeys } from '@lukemorales/query-key-factory';

export const checkout = createQueryKeys('checkout', {
    expressConfig: (locale: string, cartCountry: string, isCustomerSignedIn: boolean) => ({
        queryKey: [locale, cartCountry, isCustomerSignedIn],
    }),
});
